<template lang="pug">
el-dialog#request(title="CUONAを追加する" width="35%" custom-class="requestDialog" :visible.sync="isShowingDialog" @closed="closedCuonaRequestDialog")
  .request-content
    #cube
      img(:src="images.cube")
      h2 CUONA CUBE
      el-input-number(size="mini" v-model="cuonaRequestDialogForm.cube.count" :min="0")
    #tag
      img(:src="images.tag")
      h2 CUONA TAG
      el-input-number(size="mini" v-model="cuonaRequestDialogForm.tag.count" :min="0")

  footer.dialog-footer(slot="footer")
    el-button.add_request(type="primary" @click="requestDevice") 追加申請する
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      isShowingDialog: this.showing,
      cuonaRequestDialogForm: {
        cube: {
          count: 0
        },
        tag: {
          count: 0
        }
      },
      images: {
        cube: require("@/assets/cuona_cube.png"),
        tag: require("@/assets/cuona_tag.svg")
      }
    }
  },
  props: ['showing'],
  computed: {
    ...mapState({
      deviceRequests: state => state.user.deviceRequests
    })
  },
  watch: {
    showing : function() {
      this.isShowingDialog = this.showing
    },
  },
  methods: {
    // デバイス購入申請
    requestDevice: function() {
      var params = this.cuonaRequestDialogForm
      if(0 < params.cube.count || 0 < params.tag.count){
        this.$store.dispatch('createDeviceRequest', params)
          .then(() => {
            this.$message({
              showClose: true,
              message: 'オーナーに申請しました',
              type: 'success'
            });
          })
          .finally(() => {this.isShowingDialog = false})
      } else {
        this.$message({
          showClose: true,
          message: '追加する個数を入力してください',
          type: 'error'
        });
      }
    },

    // 申請ダイアログが閉じたときの処理
    closedCuonaRequestDialog: function() {
      this.$parent.isShowingDialog = false
      this.cuonaRequestDialogForm.cube.count = 0
      this.cuonaRequestDialogForm.tag.count = 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.request-content {
  display: flex;
  margin: 10px 20px 0 20px;
}

#cube, #tag {
  flex-grow: 1;
  border: 1px solid $border;
  border-radius: 5px;
  padding: 40px;
  margin-right: 20px;
  text-align: center;

  img {
    width: 130px;
  }

  h2 {
    font-size: 14px;
  }
}

#tag {
  margin-right: 0;
  img {
    width: 100px;
    margin-bottom: 6px;
  }
}

.dialog-footer {
  text-align: center;
}

.add_request {
  width: 200px;
}

#request ::v-deep {
  .requestDialog {
    min-width: 530px;
    width: 35%;

    .el-dialog__header {
      text-align: center;
    }
  }
}

</style>
